/**
 * Bandeau unique « Les menus ont été simplifiés » (module `navigation_v3`,
 * ADR 0069) : dit où se trouvent les pages devenues des onglets, puis ne
 * revient plus pour cette personne.
 */
import { Info, X } from "lucide-react";
import { useState } from "react";

import { NAV_V3_GROUPS, navGroupsFor } from "@/config/navigation";
import { useAuthStore } from "@/features/auth/store";
import { markNavV3NoticeSeen, navV3NoticeSeen } from "@/lib/nav-v3-notice";

export function NavV3Notice() {
  const me = useAuthStore((s) => s.me);
  const [closed, setClosed] = useState(false);

  if (
    !me ||
    closed ||
    navGroupsFor(me) !== NAV_V3_GROUPS ||
    navV3NoticeSeen(me.id)
  )
    return null;

  const close = () => {
    markNavV3NoticeSeen(me.id);
    setClosed(true);
  };

  return (
    <div
      role="status"
      className="border-b border-border bg-primary/10 text-sm text-foreground"
    >
      <div className="mx-auto flex w-full items-start gap-3 px-4 py-3 lg:px-6">
        <Info
          className="mt-0.5 h-4 w-4 shrink-0 text-primary-text"
          aria-hidden
        />
        <div className="min-w-0 flex-1 space-y-1">
          <p className="font-semibold">
            Les menus ont été simplifiés. Les écrans gardent leur nom.
          </p>
          <p className="text-muted-foreground">
            Familles est un onglet de Patients, Prescriptions optiques un onglet
            de Prescriptions, Rôles un onglet de Utilisateurs, Seuils de stock
            un onglet de Niveaux de stock, et Fournisseurs un onglet de Achats /
            réceptions. Les rapports sont réunis dans le menu Rapports, les
            paramètres sous l'engrenage. Ctrl+K retrouve un écran par son nom.
          </p>
        </div>
        <button
          type="button"
          onClick={close}
          className="inline-flex shrink-0 items-center gap-1 border border-border bg-surface px-2 py-1 text-xs font-medium hover:bg-background focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <X className="h-3.5 w-3.5" aria-hidden />
          J'ai compris
        </button>
      </div>
    </div>
  );
}
